export default __webpack_public_path__ + "static/media/Hockey Stadium, PKL5.7231f5d8.jpg";